import { makeEnvironmentProviders } from '@angular/core';

import { ApplicationInsightsMonitoringService } from './application-insights-monitoring.service';
import {
  APPLICATION_INSIGHTS_CONFIG,
  ApplicationInsightsConfig,
} from './application-insights.model';
import { MonitoringService } from './monitoring-service';

function _provideApplicationInsightsMonitoring(
  config: ApplicationInsightsConfig
) {
  return [
    {
      provide: MonitoringService,
      useClass: ApplicationInsightsMonitoringService,
    },
    { provide: APPLICATION_INSIGHTS_CONFIG, useValue: config },
  ];
}

export function provideApplicationInsightsMonitoring(
  config: ApplicationInsightsConfig
) {
  return makeEnvironmentProviders(
    _provideApplicationInsightsMonitoring(config)
  );
}
